import dateFormat from 'dateformat';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { formatPrice } from './repurchase/util';

// Internal
// --------

function _formatDate(strValue) {
  const date = new Date(strValue);
  return dateFormat(date, 'dddd, mmmm dS h:MM TT Z');
}

function PromotionBanner({ endDate, maxSavings }) {
  const { ready: translationLoaded } = useTranslation('self-service/packages/promotion-banner');

  // Render

  if (!translationLoaded || !Date.parse(endDate) || !maxSavings) {
    return null;
  }

  return (
    <div className="promotion-banner">
      <p className="promotion-banner__message">
        <Trans
          i18nKey="limitedTimeMessage"
          defaults="Up to {{ value }} off through {{ date }}" // optional defaultValue
          components={{ bold: <strong /> }}
          values={{ date: _formatDate(endDate), value: formatPrice(maxSavings) }}
        />
      </p>
    </div>
  );
}

PromotionBanner.propTypes = {
  endDate: PropTypes.string,
};

// Exports
// -------

export default PromotionBanner;
